<template>
        <div>
        <section class="container mt-3 py-3">
            <h4>Card title</h4>
            <p>Aqui se muestra una tarjeta simple donde se incluyen los siguientes datos: Titulo, subtitulo, descripción del "card" y dos link 
                que redireccionan a otra pagina.
            </p>
            <div class="mt-3 mb-4">
                <!-- sección del card -->
                <div class="card" style="width: 18rem;">
                    <div class="card-body">
                        <h5 class="card-title">Card title</h5>
                        <h6 class="card-subtitle mb-2 text-muted">Card subtitle</h6>
                        <p class="card-text">Some quick example text to build on the card title and make up the bulk
                         of the card's content.</p>
                        <a href="#" class="card-link">Card link</a>
                        <a href="#" class="card-link">Another link</a>
                    </div>
                </div>
                <!-- end sección del card -->
            </div>
            <p>Clases a utilizar en este componente</p>
            <code>.card <br>
                .card-body <br>
                .card-title <br>
                .card-subtitle <br>
                .card-text <br>
            </code>
            <p>Codigo de ejemplo para usar estos componentes</p>
            <div class="p-3 bg-white" v-highlight><pre class="language-html p-0"><code><script type="text/plain" class="language-markup"><div class="card" style="width:18rem;">
    <div class="card-body">
        <h5 class="card-title">Card title </h5>
        <h6 class="card-subtitle mb-2 text-muted"> Card Subtitle </h6>
        <p class="card-text"> Texto de ejemplo </p>
        <a href="#" class="card-link"> Card link </a>
        <a href="#" class="card-link"> Card link </a>
    </div>
</div>
</script></code></pre>
    </div>
        </section>
        <!-- List groups -->
        <section class="container mt-3 py-3">
            <h4>List groups</h4>
            <p>Aqui se muestra una tarjeta simple donde se incluyen los siguientes datos: Titulo, subtitulo, descripción del "card" y dos link 
                que redireccionan a otra pagina.
            </p>
            
            <div class="mt-3 mb-4">
                <div class="card" style="width: 18rem;">
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item">Primer item</li>
                        <li class="list-group-item">Segundo item</li>
                        <li class="list-group-item">Tercer item</li>
                    </ul>
                </div>
            </div>
            <!-- Explicación -->
            <p>Clases a utilizar en este componente</p>
            <code>.card <br>
                .list-group <br>
                .list-group-flush<br>
                .list-group-item <br>
            </code>
            <p>Codigo de ejemplo para usar estos componentes</p><br>
            <p>Para personalizar el tamaño de su card. Puede modificarlo editando en la etiquta "style" el elemento "width".</p>
            <!-- CODIGO HTML -->
            <div class="p-3 bg-white" v-highlight><pre class="language-html p-0"><code><script type="text/plain" class="language-markup"><div class="card" style="width:18rem;">
    <ul class="list-group list-group-flush">
        <li class="list-group-item"> Primer item </li>
        <li class="list-group-item"> Segundo item </li>
        <li class="list-group-item"> Tercer item </li>
    </ul>
</div>
</script></code></pre>
    </div>
            <!-- CODIGO HTML -->
            <!-- Header and footer -->
        </section>
        <section class="container mt-3 py-3">
            <h4>Header and footer</h4>
            <p>Aqui se muestra una tarjeta simple donde se incluyen los siguientes datos: Titulo, subtitulo, descripción del "card" y dos link 
                que redireccionan a otra pagina.
            </p>
                        <!-- card -->
            <div class="mt-3 mb-4">
                <div class="card">
                    <div class="card-header">
                        Featured
                    </div>
                    <div class="card-body">
                        <h5 class="card-title">Special title treatment</h5>
                        <p class="card-text">With supporting text below as a natural lead-in to additional content.</p>
                        <vs-button href="#" class="btn-primary">Go somewhere</vs-button>
                    </div>
                </div>
            </div>
            <!-- card -->
            <!-- explicación -->
            <code>.card <br>
                .card-header <br>
                .card-body<br>
                .card-title<br>
                .card-text <br>
            </code>
            <p>Codigo de ejemplo para usar estos componentes</p>
            <!-- CODIGO HTML -->
             <div class="p-3 bg-white" v-highlight><pre class="language-html p-0"><code><script type="text/plain" class="language-markup"><div class="card">
    <div class="card-header">
        Featured
    </div>
    <div class="card-body">
        <h5 class="card-title">Special title treatment</h5>
        <p class="card-text"> With supporting text below as natural lead-in to aditional content. </p>
        <vs-button href="#" class="btn-primary">Go somewhere</vs-button>
    </div>
</div>
</script></code></pre>
    </div>   
        </section>
    </div>
</template>
<script>
    export default {
        created(){
        window.scrollTo(0, 0);
    },
    data:function(){
        return{

            htmlcard:'<div class="',
            htmlcard1:'</div>',
            htmlcard2:'<h5 class="',
            htmlcard3:'<h6 class="',
            htmlcard4:'<p class="',
            htmlcard5:'<a href="#" class="card-link"> Card link </a>',
            htmlcard6:'</h5>',
            htmlcard7:'</h6>', 
            htmlcard8:'</p>', 
            htmlcard9:'<a href="#" class="btn btn-primary">Go somewhere</a>',
            listgroup:'<ul class="',
            listgroup2:'</ul>',
            listgroup3: '<li class="',
            listgroup4:'</li>'
            // htmlvalue3: '<label class="labelTextarea" for="TextareaName">Ingrese su comentario</label>',
        }
    }
}
</script>